// extracted by mini-css-extract-plugin
export var gif = "_ib-0";